<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="тип расхода"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-item-by-id="getLocationCostType"
      :get-list="getItems"
      :can-create-catalog="canEditLocationCostType()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <location-cost-type
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import CatalogSelect from "../CatalogSelect.vue";
    import LocationCostType from "./LocationCostType.vue";

export default {
  name: "LocationCostTypeSelect",
  components: { LocationCostType, CatalogSelect},
  mixins: [
    catalogs,
    permissions
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getLocationCostTypesSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getLocationCostType(id) {
      const result = await this.getLocationCostTypeById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    canEditLocationCostType() {
      return this.hasPermission([PERM.CATALOG_LOCATION_COST_TYPE_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LocationCostTypes/LocationCostTypeSelect.vue